// extracted by mini-css-extract-plugin
export default {"movieCard":"ssearch_movieCard__7XYXg","movieCardImg":"ssearch_movieCardImg__hmRkE","movieCardhov":"ssearch_movieCardhov__gJ9HO"};